//-----------------------------------------------------------------------
// Copyright © 2022 ManpowerGroup. All Rights Reserved.
//-----------------------------------------------------------------------

/* eslint-disable prettier/prettier */
import React, { useEffect, useContext, useState } from "react";
import { Helmet } from "react-helmet-async";
import { Col, Container, Row, ListGroup, Tab } from "react-bootstrap";
import ManageClientSpecificContent from "./manageClientSpecificContent";
import AddClientSpecificContent from "./addClientSpecificContent";
import ErrorAlertMessage from "../common/alertMessages/errorAlertMessage";
import { ManageClientsActions } from "../clients/manageClients/manageClientsActions";

const ClientSpecificMapping = ({ cmsData }) => {

    const [clientSpecificCMSData, setClientSpecificCMSData] = useState({ title: "", description: "", tabNavigationTitle: "", pageContent: {} });
    const [errorAlert, setErrorAlert] = useState({
        showAlert: false
    })
    const showErrorModal = () => {
        let refErrorMessageAlert = JSON.parse(JSON.stringify(errorAlert));
        refErrorMessageAlert.showAlert = false;
        setErrorAlert(refErrorMessageAlert)
    }

    const fetchClientSpecificLabel = (key) => {
        if (clientSpecificCMSData?.pageContent && clientSpecificCMSData?.pageContent["ClientSpecificContentComponent"]) {
            const clientSpecificCMSDataLabel = clientSpecificCMSData.pageContent["ClientSpecificContentComponent"];
            return ManageClientsActions.returnLabel(clientSpecificCMSDataLabel?.Labels, key)
        }
        return '';
    };

    useEffect(() => {
        setClientSpecificCMSData(cmsData)
    }, [cmsData]);

    return (
        <React.Fragment>
            <Helmet title="Tabs" />
            <Container fluid className="p-0">
                {errorAlert?.showAlert &&
                    <ErrorAlertMessage alertMessage="AllPages.ErrorAlertMessage" showAlert={showErrorModal} />
                }
                <br />
                <Row>
                    <Col lg="12">
                        <Tab.Container id="clientspecific-tabs" defaultActiveKey="#manageclientspecificcontent">
                            <ListGroup horizontal>
                                <ListGroup.Item action href="#manageclientspecificcontent">
                                    {fetchClientSpecificLabel('ClientSpecificContent.ManageClientSpecific')}
                                </ListGroup.Item>
                                <ListGroup.Item action href="#addanewclientspecificcontent">
                                    {fetchClientSpecificLabel('ClientSpecificContent.AddNewClientSpecific')}
                                </ListGroup.Item>
                            </ListGroup>
                            <Tab.Content>
                                <Tab.Pane eventKey="#manageclientspecificcontent">
                                    <ManageClientSpecificContent cmsData={clientSpecificCMSData?.pageContent && clientSpecificCMSData} />
                                </Tab.Pane>
                                <Tab.Pane eventKey="#addanewclientspecificcontent">
                                    <AddClientSpecificContent cmsData={clientSpecificCMSData?.pageContent && clientSpecificCMSData} />
                                </Tab.Pane>
                            </Tab.Content>
                        </Tab.Container>
                    </Col>
                </Row>
            </Container>
        </React.Fragment >
    )
}
export default ClientSpecificMapping;
